<template>
  <BaseModal
    v-if="$page.props.recordableCallsModal"
    :name="RECORDING_FEATURE_PRESENTATION_MODAL_NAME"
    :click-outside-to-close="false"
    width-class="tw-max-w-[500px] tw-overflow-hidden"
    modal-class="tw-pt-32"
    is-background-blurred
    :auto-focus="false"
  >
    <div class="video-room-modal-background tw-px-4 tw-pb-4 tw-pt-10">
      <BaseCarousel
        :slides-data="slidesData"
        is-pagination-enabled
        arrow-classes="tw-bg-neutral-900 tw-text-white tw-border-none tw-h-8 tw-w-8"
        arrow-icon-classes="tw-w-3 tw-h-4"
        :breakpoints="{
          1: { slidesPerView: 1 },
        }"
      >
        <template #slide="{ slideData }">
          <div class="tw-text-center">
            <div class="tw-display-1">{{ slideData.title }}</div>
            <div class="tw-mt-2 tw-text-sm tw-text-neutral-600">
              {{ slideData.description }}
            </div>
            <img
              v-if="slideData.id === 1"
              src="@/assets/images/video-room-chat-gpt.png"
              alt=""
              class="tw-mx-auto tw-mt-6 tw-w-64"
            />
            <img :src="slideData.image" alt="" class="tw-mt-6 tw-w-full" />
          </div>
          <div class="tw-p-4">
            <p class="tw-text-neutral-600 tw-text-sm">
              {{ slideData.bottomDescription }}
            </p>
            <!-- prettier-ignore -->
            <p class="tw-mt-4 tw-text-neutral-600 tw-text-sm">
              Want to opt out? You can disable recordings in <button @click="navigateToSettings" class="tw-link">Settings</button>.
            </p>
          </div>
        </template>
      </BaseCarousel>
      <div>
        <div
          class="tw-text-center tw-text-xs tw-text-neutral-400 tw-underline"
        >
          <a
            href="https://www.growthmentor.com/faq/ai-recording"
            target="_blank"
          >
            Want to learn more about how AI Recordings work?
          </a>
        </div>
        <div class="tw-mt-6 tw-flex tw-justify-center">
          <BaseButton
            @click="closeModal(RECORDING_FEATURE_PRESENTATION_MODAL_NAME)"
            color="outline-gray"
            size="large"
          >
            Close
          </BaseButton>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script setup lang="ts">
import { RECORDING_FEATURE_PRESENTATION_MODAL_NAME } from '@/shared/data/globalVariables.js'
import BaseModal from '@/shared/components/BaseModal.vue'
import BaseCarousel from '@/shared/components/BaseCarousel.vue'
import FirstCardImage from '@/assets/images/video-recording-card-1.png'
import SecondCardImage from '@/assets/images/video-recording-card-2.png'
import ThirdCardImage from '@/assets/images/video-recording-card-3.png'
import BaseButton from '@/shared/components/BaseButton.vue'
import { useModals } from '@/shared/composables/useModals.js'
import { router } from '@inertiajs/vue3'

const { closeModal } = useModals()

const slidesData = [
  {
    id: 1,
    title: 'Your Mentor Sessions Just Got Smarter!',
    description: 'Every session now comes with AI-powered summaries and actionable insights to help you get more value from your conversations.',
    image: FirstCardImage,
    bottomDescription: 'We\'ve upgraded our Video Room with automatic recording and AI analysis. Get structured summaries, key takeaways, and follow-up actions from every session - all in one place.',
  },
  {
    id: 2,
    title: 'Your Personal Growth Library',
    description: 'All your recorded sessions, organized and analyzed for easy reference.',
    image: SecondCardImage,
    bottomDescription: 'Browse through your past sessions, complete with AI summaries and insights. Never lose track of valuable advice and action items from your mentoring conversations.',
  },
  {
    id: 3,
    title: 'Smart Session Insights',
    description: 'Get more from every conversation with AI-powered analysis',
    image: ThirdCardImage,
    bottomDescription: 'Your AI summary transforms each session into a structured overview with discussion highlights, concrete next steps, and targeted follow-up questions. Review key points anytime to stay on track with your growth goals.',
  },
]

const navigateToSettings = () => {
  closeModal(RECORDING_FEATURE_PRESENTATION_MODAL_NAME)
  router.visit('/settings/profile/communication')
}
</script>

<style scoped>
.video-room-modal-background {
  background-image: url('@/assets/images/video-room-modal-background.png');
  @apply tw-bg-cover tw-bg-center tw-bg-no-repeat;
}
</style>
